<template>
  <div id="header">
    <el-row>
      <el-col :span="4" class="titleLeft">
        <!-- <h3 class="sysTitle">{{ $t("headerBar.sysTitle") }}</h3> -->
        <el-image :src="titleImgUrl"></el-image>
      </el-col>
      <el-col :span="12" class="middleMenu">
        <el-menu
          :default-active="activeMenu"
          router
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item
            v-for="(item, index) in menuData"
            :key="index"
            :index="item.path"
          >
            <!-- {{ item.title }} -->
            {{ $t(`menu.${item.title}`) }}
          </el-menu-item>
        </el-menu>
      </el-col>

      <el-col :span="8" class="headerRigth">
        <!-- 切换中英文 -->
        <el-tooltip
          class="item"
          effect="light"
          :content="locale == 'zh_cn' ? '切换为英文' : 'Switch to Chinese'"
          placement="bottom"
          :visible-arrow="false"
        >
          <div
            v-if="locale == 'zh_cn'"
            @click="toggleLang('en')"
            class="headOperate"
            title=""
          >
            Zh
          </div>
          <div
            v-if="locale == 'en'"
            @click="toggleLang('zh_cn')"
            class="headOperate"
            title=""
          >
            En
          </div>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="light"
          :content="$t('headerBar.returnToLearningPlatform')"
          placement="bottom"
          :visible-arrow="false"
        >
          <div class="headOperate" title="" @click="goLearnSys">
            <el-image class="goLearnSys" :src="goLearnSysImgUrl"></el-image>
          </div>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="
            fullscreen
              ? $t('headerBar.exitFullScreen')
              : $t('headerBar.fullScreen')
          "
          placement="bottom"
          :visible-arrow="false"
        >
          <div class="headOperate" @click="handleScreen">
            <el-image class="allscreen" :src="allscreenImgUrl"></el-image>
          </div>
        </el-tooltip>
        <!-- 切换角色 -->
        <el-tooltip
          class="item"
          effect="light"
          v-if="
            userInfo.is_admin ||
            userInfo.is_exam_admin ||
            userInfo.is_open_teacher ||
            userInfo.is_grade_teacher
          "
          :content="
            roleName[0] === 'stu'
              ? $t('headerBar.switchAdministratorRole')
              : $t('headerBar.switchStudentRole')
          "
          placement="bottom"
          :visible-arrow="false"
        >
          <div class="headOperate" title="" @click="handleSwitchRoles">
            <el-image
              class="goLearnSys"
              :src="
                roleName[0] === 'stu' ? studentRoleImgUrl : managerRoleImgUrl
              "
            ></el-image>
          </div>
        </el-tooltip>
        <div class="headOperate userImg">
          <el-avatar :src="userImgUrl"></el-avatar>
        </div>
        <el-dropdown class="addExamPaperBtn" @command="handleCommand">
          <div class="avatar-dropdown d-flex-between">
            <div class="user-name">
              <span class="hidden-sm-and-down userName">{{
                userInfo.fullname
              }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{
              $t("headerBar.logOut")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
    <OperateTips ref="logout" @sureDel="getSureDel"></OperateTips>
  </div>
</template>
<script>
import routes from "@/router";
import OperateTips from "@/components/dialogComponents/OperateTips.vue";
import { domainName } from "@/config/index.js";
import { arrayComparison } from "@/utils/validate";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    OperateTips,
  },
  data() {
    return {
      fullscreen: false,
      activeIndex: "题库管理",
      titleImgUrl: require("@/assets/images/common/LOGO_mtutest.png"),
      goLearnSysImgUrl: require("@/assets/images/common/icon_title_home_hover.png"),
      allscreenImgUrl: require("@/assets/images/common/icon_title_fullscreen_hover.png"),
      managerRoleImgUrl: require("@/assets/images/common/icon_dientity_manager_hover.png"),
      studentRoleImgUrl: require("@/assets/images/common/icon_identity_student_hover.png"),
      userImgUrl: require("@/assets/images/common/userImg.png"),
    };
  },
  computed: {
    // 返回当前地区信息
    locale() {
      return this.$i18n.locale;
    },

    ...mapState("user", ["roleName", "userInfo"]),
    menuData() {
      let headerRoute;
      headerRoute = routes.options.routes[1].children.filter((item) => {
        return (
          item.hidden == false &&
          arrayComparison(item.meta.roles, this.roleName)
        );
      });
      return headerRoute;
    },
    activeMenu() {
      const clickRoutes = this.$route;
      const { meta, path } = clickRoutes;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    // i18n
    async toggleLang(lang) {
      if (lang == "zh_cn") {
        localStorage.setItem("locale", "zh_cn");
        this.$i18n.locale = localStorage.getItem("locale");
        // this.$store.commit("setlang", "cn");
      } else if (lang == "en") {
        localStorage.setItem("locale", "en");
        this.$i18n.locale = localStorage.getItem("locale");
        // this.$store.commit("setlang", "en");
      }
    },
    ...mapMutations("user", ["setRoleName"]),
    // 获取登录用户信息
    async getUserInfo() {
      try {
        let userInfo = await this.$store.dispatch("user/getUserInfo");
        this.$store.commit("user/setUserInfo", userInfo);
        console.log("当前登录用户信息：", this.$store.state.user.userInfo);
      } catch (error) {
        console.log("error", error);
      }
    },
    // 返回学习平台
    goLearnSys() {
      window.location.href = domainName;
    },
    handleSelect(index, indexPath) {
      console.log(index + "--" + indexPath);
    },
    // 进入或退出全屏
    handleScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    // 切换角色
    handleSwitchRoles() {
      const { is_admin, is_exam_admin, is_grade_teacher, is_open_teacher } =
        this.userInfo;
      if (this.roleName[0] === "stu") {
        let roleArr = [];
        if (is_admin) {
          roleArr.push("admin");
        } else {
          if (is_exam_admin) roleArr.push("examAdmin");
          if (is_open_teacher) roleArr.push("openTea");
          if (is_grade_teacher) roleArr.push("gradeTea");
        }
        this.setRoleName(roleArr);
      } else {
        this.setRoleName(["stu"]);
      }
      if (["admin", "examAdmin", "openTea"].includes(this.roleName[0])) {
        this.$router.push({
          path: "/index",
        });
      } else if (this.roleName[0] === "gradeTea") {
        this.$router.push({
          path: "/examMarking",
        });
      } else {
        this.$router.push({
          path: "/myExams",
        });
      }
    },
    // 退出登录
    handleCommand(command) {
      console.log("command", command);
      switch (command) {
        case "logout":
          console.log("logout");
          this.$refs.logout.isDeleteVisible = true;
          this.$refs.logout.dialogTitle = "是否确认退出登录？";
          break;
      }
    },
    logout() {
      this.$store.commit("user/setAccessToken", null);
      this.$store.commit("user/setRoleName", ["stu"]);
      // let addr;
      // if (domainName == "https://xiangyi.mtu.plus") {
      //   addr = "https://xiangyi.mtu.plus/login/index.php";
      // } else if (domainName == "https://moodle.chenkf.cn") {
      //   addr = "https://moodle.chenkf.cn/login/index.php";
      // } else if (domainName == "http://xylms.zhftc.com") {
      //   addr = "http://xylms.zhftc.com/login/index.php";
      // }
      let addr = domainName + "/login/index.php";
      window.location.href =
        domainName + "/local/exam/logout.php?callback=" + addr;
      // console.log(
      //   ' domainName + "/local/exam/logout.php?callback=" + addr',
      //   domainName + "/local/exam/logout.php?callback=" + addr
      // );
    },
    getSureDel() {
      this.logout();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  // .el-row {
  //   box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
  // }
  .el-menu-vertical-demo {
    .el-menu-item {
      height: auto;
      line-height: 40px;
      font-size: 16px;
    }
  }
}
#header {
  padding-top: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
  .titleLeft {
    .sysTitle {
      font-size: 28px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #002350;
      line-height: 28px;
      margin: 0 0 0 30px;
      padding-bottom: 24px;
    }
    .el-image {
      margin-left: 30px;
      height: 45px;
      width: auto;
    }
  }
  .middleMenu {
    .el-menu.el-menu--horizontal {
      border: none;
    }
    .el-menu-item {
      font-size: 20px;
      color: #999999;
      height: auto;
      line-height: 35px;
      padding-bottom: 18px;
      border: none;
    }
    .is-active {
      font-size: 24px;
      border: none;
      color: #002350;
      font-weight: bold;
      position: relative;
    }
    .is-active::after {
      content: "";
      display: inline-block;
      width: 36px;
      height: 6px;
      background-image: url("@/assets/images/common/icon_title_sel.png");
      position: absolute;
      bottom: -5px;
      left: 50%;
      transform: translate(-50%);
    }
  }

  .headerRigth {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 40px;
    float: right;
    .headOperate {
      width: 40px;
      height: 40px;
      border: 1px solid #116ebb;
      background: rgba(17, 110, 187, 0.1);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-left: 24px;

      .img {
        width: 100%;
        height: 100%;
      }
    }
    .userImg {
      width: 42px;
      height: 42px;
      border: none;
      margin-right: 8px;
    }
    .userName {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #333333;
    }
    // .user-avatar {
    //   flex: 0 0 36px;
    //   width: 36px;
    //   height: 36px;
    //   cursor: pointer;
    //   border-radius: 50%;
    //   border: 2px solid #ffffff;
    // }

    .user-name {
      cursor: pointer;
    }
  }
}
</style>
